import { c as _c } from "react/compiler-runtime";
import { alpha, Box, useTheme } from "@mui/material";
import React, { useMemo } from "react";
import { arrayDataItemSelectors } from "#/entities/dataStructures/array/model/arraySlice";
import { type ArrayStructureViewProps } from "#/entities/dataStructures/array/ui/ArrayStructureView";
import { MapItem } from "#/entities/dataStructures/map/ui/MapItem";
type MapStructureViewProps = ArrayStructureViewProps;
export const MapStructureView: React.FC<MapStructureViewProps> = t0 => {
  const $ = _c(29);
  const {
    data,
    parentColorMap,
    sx
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== data.nodes) {
    t1 = arrayDataItemSelectors.selectAll(data.nodes);
    $[0] = data.nodes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const items = t1;
  let t2;
  if ($[2] !== theme.palette.primary.light) {
    t2 = alpha(theme.palette.primary.light, 0.3);
    $[2] = theme.palette.primary.light;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `1px solid ${t2}`;
  let t4;
  if ($[4] !== theme.palette.primary.light) {
    t4 = alpha(theme.palette.primary.light, 0.8);
    $[4] = theme.palette.primary.light;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `1px solid ${t4}`;
  let t6;
  if ($[6] !== t5) {
    t6 = {
      border: t5
    };
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      "& > td:first-of-type": {
        borderTopLeftRadius: "4px"
      },
      "& > td:last-child": {
        borderTopRightRadius: "4px"
      },
      "&::after": {
        borderRadius: "4px 4px 0 0"
      }
    };
    t8 = {
      "& > td:first-of-type": {
        borderBottomLeftRadius: "4px"
      },
      "& > td:last-child": {
        borderBottomRightRadius: "4px"
      },
      "&::after": {
        borderRadius: "0 0 4px 4px"
      }
    };
    $[8] = t7;
    $[9] = t8;
  } else {
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] !== sx || $[11] !== t3 || $[12] !== t6) {
    t9 = {
      width: "fit-content",
      borderCollapse: "separate",
      borderSpacing: 0,
      border: t3,
      borderRadius: "4px",
      "&:hover": t6,
      "& tr:first-of-type": t7,
      "& tr:last-child": t8,
      ...sx
    };
    $[10] = sx;
    $[11] = t3;
    $[12] = t6;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== data.colorMap || $[15] !== items || $[16] !== parentColorMap) {
    let t11;
    if ($[18] !== data.colorMap || $[19] !== parentColorMap) {
      t11 = item => <MapItem key={item.id} item={item} colorMap={data.colorMap ?? parentColorMap} />;
      $[18] = data.colorMap;
      $[19] = parentColorMap;
      $[20] = t11;
    } else {
      t11 = $[20];
    }
    t10 = items.map(t11);
    $[14] = data.colorMap;
    $[15] = items;
    $[16] = parentColorMap;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[21] !== items.length) {
    t11 = items.length === 0 && <tr><Box component="td" sx={{
        width: 44,
        height: 44
      }} /></tr>;
    $[21] = items.length;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <tbody>{t10}{t11}</tbody>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t9) {
    t13 = <Box component="table" sx={t9}>{t12}</Box>;
    $[26] = t12;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};